// extracted by mini-css-extract-plugin
module.exports = {"allNotifications":"notification_allNotifications__3ri6Y","notificationContainerInside":"notification_notificationContainerInside__1GGLO"};